import { render, staticRenderFns } from "./buygoods.vue?vue&type=template&id=3055516e&scoped=true"
import script from "./buygoods.vue?vue&type=script&lang=js"
export * from "./buygoods.vue?vue&type=script&lang=js"
import style0 from "./buygoods.vue?vue&type=style&index=0&id=3055516e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055516e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3055516e')) {
      api.createRecord('3055516e', component.options)
    } else {
      api.reload('3055516e', component.options)
    }
    module.hot.accept("./buygoods.vue?vue&type=template&id=3055516e&scoped=true", function () {
      api.rerender('3055516e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/drugprocurement/buygoods.vue"
export default component.exports